<template>
  <div class="admin-panel">
    <div class="container">
      <div class="admin-login-wrapper">
        <div class="admin-login">
          <div class="column-left">
            <b-img class="d-block logo" src="@/assets/logo_text.png"></b-img>
          </div>
          <div class="column-right">
            <div class="login-dialog">
              <h4 class="title">Admin Panel</h4>
              <input
                v-model="adminUserInput"
                type="text"
                placeholder="Username"
                class="form-control mt-4"
                :class="{ 'input-error': errorMessage }"
                @keyup.enter="adminLogin"
              />
              <div class="password-wrapper mt-4">
                <input
                  v-model="adminPasswordInput"
                  :type="showPassword ? 'text' : 'password'"
                  placeholder="Password"
                  class="form-control"
                  :class="{ 'input-error': errorMessage }"
                  @keyup.enter="adminLogin"
                />
                <button type="button" class="toggle-password" @click="togglePassword">
                  <fa-icon :icon="showPassword ? ['fas', 'eye'] : ['fas', 'eye-slash']" />
                </button>
              </div>
              <div class="mt-4 text-center">
                <button
                  class="btn btn-login"
                  @click="adminLogin"
                  :disabled="!adminUserInput.trim() || !adminPasswordInput.trim()"
                >
                  Login
                </button>
              </div>
              <div class="error mt-2 text-center" v-if="errorMessage">{{ errorMessage }}</div>
              <div class="staff-link mt-3 text-center">
                <router-link :to="{ name: 'Staff-Login', params: { lang: $i18n.locale } }" class="staff-portal-link">
                  Staff Portal Login
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiFetch } from '@/services/api'
import { encryptPassword } from '@/services/crypto'

export default {
  name: 'admin-login',
  metaInfo () {
    const title = 'Tyng & Co | Admin Login'
    const description = 'Admin Login'
    document.querySelector('meta[name="description"]').content = description
    return {
      title,
      titleTemplate: null,
      meta: [{ vmid: 'description', name: 'description', content: description }],
      link: [{ rel: 'canonical', href: `https://tyng-ca.com.my/${this.$i18n.locale}/admin-login` }]
    }
  },
  data () {
    return {
      adminUserInput: '',
      adminPasswordInput: '',
      errorMessage: '',
      showPassword: false
    }
  },
  mounted () {
    if (localStorage.getItem('adminToken')) {
      this.$router.replace({ name: 'Admin-Panel', params: { lang: this.$i18n.locale } })
    }
  },
  methods: {
    async adminLogin () {
      try {
        const encryptedPassword = await encryptPassword(this.adminPasswordInput)
        const data = await apiFetch('/api/admin/login.php', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            username: this.adminUserInput,
            encrypted_password: encryptedPassword
          })
        })

        if (data.success) {
          if (data.role === 'staff') {
            this.errorMessage = 'Staff accounts must log in via the Staff Portal.'
            return
          }
          localStorage.setItem('adminToken', data.token)
          localStorage.setItem('adminRole', data.role || 'admin')
          if (data.refresh_token) {
            localStorage.setItem('adminRefreshToken', data.refresh_token)
          }
          this.$router.push({ name: 'Admin-Panel', params: { lang: this.$i18n.locale } })
        } else {
          this.errorMessage = data.message || 'Login failed'
        }
      } catch (err) {
        this.errorMessage = err?.message || 'Invalid credentials'
      }
    },
    togglePassword () {
      this.showPassword = !this.showPassword
    }
  },
  watch: {
    adminUserInput () {
      if (this.errorMessage) this.errorMessage = ''
    },
    adminPasswordInput () {
      if (this.errorMessage) this.errorMessage = ''
    }
  }
}
</script>

<style scoped>
.staff-portal-link {
  font-size: 13px;
  color: #64748b;
  text-decoration: none;
}
.staff-portal-link:hover { color: #1a3c6e; text-decoration: underline; }
</style>
